// Generates and triggers a .ics download client-side — no backend needed.
// Works on iOS Calendar, Google Calendar, Apple Calendar, Outlook.

const EVENT = {
  title: "Scott & Isabelle's Wedding",
  start: "20261030T143000",    // Oct 30, 2026 — 2:30 pm
  end: "20261030T230000",      // — 11:00 pm
  tz: "Australia/Brisbane",    // AEST, no DST
  location: "The Dairy, Ravensbourne — 70 Philp Road, Ravensbourne QLD 4352, Australia",
  description: "We can't wait to celebrate with you. — Scott & Isabelle",
  url: "https://thebakerswedding.com",
};

function buildIcs() {
  const stamp = new Date().toISOString().replace(/[-:]|\.\d{3}/g, "");
  const uid = `bakers-wedding-${EVENT.start}@thebakerswedding.com`;
  // Escape commas, semicolons, newlines per RFC 5545
  const esc = (s) => String(s).replace(/[\\,;]/g, (m) => `\\${m}`).replace(/\n/g, "\\n");
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//The Bakers//Wedding//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${stamp}`,
    `DTSTART;TZID=${EVENT.tz}:${EVENT.start}`,
    `DTEND;TZID=${EVENT.tz}:${EVENT.end}`,
    `SUMMARY:${esc(EVENT.title)}`,
    `LOCATION:${esc(EVENT.location)}`,
    `DESCRIPTION:${esc(EVENT.description)}`,
    `URL:${EVENT.url}`,
    "BEGIN:VALARM",
    "ACTION:DISPLAY",
    "DESCRIPTION:Scott & Isabelle's Wedding — tomorrow!",
    "TRIGGER:-P1D",
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
}

export default function AddToCalendarButton() {
  const download = () => {
    const ics = buildIcs();
    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "the-bakers-wedding.ics";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="mt-10 text-center">
      <button
        type="button"
        onClick={download}
        data-testid="add-to-calendar"
        className="inline-block px-8 py-3 border border-[#76232F] text-[#76232F] text-[10px] uppercase tracking-[0.32em] [@media(hover:hover)]:hover:bg-[#76232F] [@media(hover:hover)]:hover:text-[#F4EBDD] active:bg-[#76232F] active:text-[#F4EBDD] transition-colors"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Add to calendar
      </button>
    </div>
  );
}
